export const EVENT_LABELS = {
  booking: '예약',
  change: '변경',
  cancel: '취소',
  adjustment: '조정',
};

export const SOURCE_LABELS = {
  import: '가져온값',
  system: '자동',
  manual: '수동',
};

export const EVENT_FILTERS = [
  { value: 'all', label: '전체' },
  { value: 'change_cancel', label: '취소/변경' },
  { value: 'customer_refund', label: '고객환불' },
  { value: 'supplier_refund', label: '공급사환불' },
  { value: 'loss', label: '수익음수' },
  { value: 'misc', label: '기타' },
];

export function num(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

export function fmt(value) {
  return num(value).toLocaleString('ko-KR');
}

export function monthText(value) {
  return value ? String(value).slice(0, 7) : '-';
}

export function dateText(value) {
  return value ? String(value).slice(0, 10) : '-';
}

export function eventMonth(row) {
  return monthText(row?.event_date);
}

export function getTotals(rows = []) {
  return rows.reduce((acc, row) => ({
    revenue_event_count: acc.revenue_event_count + num(row.revenue_event_count),
    booking_event_count: acc.booking_event_count + num(row.booking_event_count),
    change_event_count: acc.change_event_count + num(row.change_event_count),
    cancel_event_count: acc.cancel_event_count + num(row.cancel_event_count),
    customer_net_change: acc.customer_net_change + num(row.customer_net_change),
    cost_net_change: acc.cost_net_change + num(row.cost_net_change),
    supplier_refund: acc.supplier_refund + num(row.supplier_refund),
    supplier_cancel_fee: acc.supplier_cancel_fee + num(row.supplier_cancel_fee),
    additional_cost: acc.additional_cost + num(row.additional_cost),
    misc: acc.misc + num(row.misc),
    net_profit: acc.net_profit + num(row.net_profit),
  }), {
    revenue_event_count: 0,
    booking_event_count: 0,
    change_event_count: 0,
    cancel_event_count: 0,
    customer_net_change: 0,
    cost_net_change: 0,
    supplier_refund: 0,
    supplier_cancel_fee: 0,
    additional_cost: 0,
    misc: 0,
    net_profit: 0,
  });
}

export function filterEvents(events, selectedMonth, filter) {
  return events.filter((row) => {
    if (selectedMonth && eventMonth(row) !== selectedMonth) return false;
    if (filter === 'change_cancel') return row.event_type === 'change' || row.event_type === 'cancel';
    if (filter === 'customer_refund') return num(row.customer_refund) > 0 || num(row.customer_amount) < 0;
    if (filter === 'supplier_refund') return num(row.supplier_refund) > 0 || num(row.total_cost) < 0;
    if (filter === 'loss') return num(row.amount) < 0;
    if (filter === 'misc') return num(row.misc) !== 0;
    return true;
  });
}
